import { openDB } from "idb";

async function initDb() {
  console.log("Initializing IDB...");

  const db1 = await openDB("windrose", 1, {
    upgrade(db) {
      db.createObjectStore("tableData");
      db.createObjectStore("bins");
      db.createObjectStore("metadata");
    },
  });

  return db1;
}


export { initDb };
